import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { MdInbox, MdEdit, MdDelete, MdOndemandVideo } from 'react-icons/lib/md';
import { mediumModalStyle } from '../../constants';
import { withAuth } from '../../actions/';
import { fetchDelayLogs } from '../../actions/project_actions';
import { getDateValue } from '../../utils/date';
import DelayLogForm from './DelayLogForm';

class DelayLogs extends Component {

    constructor (props) {
        super(props);
        this.state = {
            toEdit: null,
            toDelete: null,
            currentPage: 1,
            itemsPerPage: 10
        }
        this.startEdit = this.startEdit.bind(this);
        this.openInNewTab = this.openInNewTab.bind(this);
        this.startDelete = this.startDelete.bind(this);
        this.onDone = this.onDone.bind(this);
        this.callDelete = this.callDelete.bind(this);
        this.putOrPost = this.putOrPost.bind(this);

        this.handleClick = this.handleClick.bind(this);
        this.changeNumItemsShown = this.changeNumItemsShown.bind(this);
    }

    componentDidMount() {
        this.loadInitial();
    }

    loadInitial () {
        this.props.fetchDelayLogs(this.props.projectId);
    }

    startEdit (toEdit) {
        this.setState({ toEdit })
    }

    startDelete (toDelete) {
        this.setState({ toDelete })
    }

    onDone (shouldFetch) {
        if (shouldFetch) this.loadInitial();
        this.setState({ toEdit: null, toDelete: null});
    }

    callDelete () {
        const { projectId, id } = this.state.toDelete;
        const url = `/projects/${projectId}/delayLogs/${id}`;
        withAuth(
      {method: 'delete', url: url},
      () => this.onDone(true)
    );
    }

    putOrPost (log) {
        let url, method;
        const { projectId } = this.props
        log.projectId = projectId;

        if (log.id) {
            method = 'put';
            url = `/projects/${projectId}/delayLogs/${log.id}`;
        } else {
            method = 'post';
            url = `/projects/${projectId}/delayLogs/`;
        }

        withAuth(
      {method, url, data: log},
      () => this.onDone(true)
    );
    }

    handleClick(event) {
        this.setState({
            currentPage: Number(event.target.id)
        });
    } 

    changeNumItemsShown(e) {
        if (e.target.value < 5 || e.target.value > this.props.delayLogs.length) {
          //console.log(this.state.currentPage);
        } else {
            this.setState({ itemsPerPage: e.target.value });
        }
    }

    renderDeleteForm () {
        return (
      <div className="alert-modal">
        <h1>Confirm Delete?</h1>
        <p>Are you sure you want to delete?</p>
        <button className="alert-cancel" onClick={this.callDelete}>Yes, Delete!</button>
        <div className="modal-close" onClick={this.onDone}>
          <span className="close"></span>
        </div>
      </div>
        )
    }

    renderEditForm (toEdit) {
        return (
      <div>
        <h1>Edit Delay Log</h1>
        <DelayLogForm
          log={toEdit}
          projectId={this.props.projectId}
          onSubmit={this.putOrPost}
        />
        <div className="modal-close" onClick={this.onDone}>
          <span className="close"></span>
        </div>
      </div>
        );
    }

    renderModal () {
       // debugger;
        const { roleModules } = this.props.permissions.editPrivileges;

        const canEdit = roleModules !== null && roleModules.includes('Delay logs') 
    ? true : false;

        if (!canEdit) return null;

        const { toEdit, toDelete } = this.state;
        const isOpen = !(toEdit === null && toDelete === null);
    
        return (
      <Modal
        isOpen={isOpen}
        style={mediumModalStyle}
        contentLabel="Log form"
      >
        {toDelete && this.renderDeleteForm()}
        {toEdit && this.renderEditForm(toEdit)}
      </Modal>
        );
    }

    renderRowButtons (log) {
        return (
      <td>
        <button onClick={() => this.startEdit(log)}>
          <span><MdEdit size={22} color='#8492a6'/></span>
        </button>
        <button onClick={() => this.startDelete(log)}>
        <span><MdDelete size={22} color='#8492a6'/></span>
        </button>
      </td>
        )
    }

    renderTable (delayLogs) {
        const { roleModules } = this.props.permissions.editPrivileges;

        const canEdit = roleModules !== null && roleModules.includes('Delay logs') 
    ? true : false;

        return (
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              {/* <th>Location</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Days</th> */}
              <th>Delay/Gain</th>
              <th>CCDs</th>
              <th>Attributed to</th>
              <th>Category and Subcategory</th>
              <th>Description</th>
              {/* <th>Attributed to</th> */}
              { canEdit ? <th>Actions</th> : null}
            </tr>
          </thead>
          <tbody>
          { delayLogs.map(log =>
            <tr key={log.id}>
              {/* <td>{log.location}</td>
              <td>{getDateValue(log.startDate)}</td>
              <td>{getDateValue(log.endDate)}</td>
              <td>{log.totalDelayDays}</td> */}
              <td>{log.delaysGainsText}</td>
              <td>{log.overallScheduleImpact}</td>
              <td>{log.attributedToText}</td>
              <td>{log.categoryAndSubcategoryText}</td>
              <td>{log.cause ? log.cause.substring(0, 50) : ''}</td>
              {/* <td>{log.attributedTo}</td> */}
              { canEdit ? this.renderRowButtons(log) : null}
            </tr>
          )}
          </tbody>
        </table>
      </div>
        );
    }

    openInNewTab() {
        const newWindow = window.open('https://ddcbenchmark.blob.core.windows.net/documents-prod/HelpVideos/Benchmark_Delay_Log.mp4', '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
      }

    render () {
        const { delayLogs } = this.props;
        const { roleModules } = this.props.permissions.editPrivileges;
        const canEdit = roleModules !== null && roleModules.includes('Delay logs') ? true : false;

        //--------------------------------------------------------------------
        const { currentPage, itemsPerPage } = this.state;

        // Logic for displaying items
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentDelayLogs = this.props.delayLogs.slice(indexOfFirstItem, indexOfLastItem);

        // Logic for displaying page numbers
        const pageNumbers = [];
       
        for (let i = 1; i <= Math.ceil(this.props.delayLogs.length / itemsPerPage); i++) {
            pageNumbers.push(i);
        }

        //-------------------------------------------------------------------------------
        return (
      <div id="delay-logs" className="row-wide project-logs">
        <div className="col s12">
          <h4 className="bar-bottom">
            <span><MdInbox size={20} /></span> Delay Logs
          </h4>
        </div>
        { canEdit ? this.renderModal() : null}
        <div className="col s12">
          { delayLogs.length
            ? this.renderTable(currentDelayLogs)
            : <div>This project has no delay logs yet.</div> }
        </div>
        { canEdit
          ? <div className="section-buttons">
          <button className="btn-save" onClick={() => this.openInNewTab()}>
          <span><MdOndemandVideo/></span> Tutorial
              </button>              
              <button className="btn-save" onClick={() => this.startEdit({})}>
                Add
              </button>
            </div>
          : null }

          {pageNumbers.length > 1 &&
          <div>
            <div className="col s12">
              <div className="controls margin-top-1">
                <label className="label-pagination">Show</label>
                <input type="number" value={itemsPerPage} onChange={this.changeNumItemsShown}
                  min="5" max={this.props.delayLogs.length - 1} className="input-pagination" />
                <span className="label-pagination">per page</span>
              </div>
            </div>

            <div className="col s12">
              <div className="pagination-blue-book">
                <ul id="page-numbers">
                  {pageNumbers.map(number => {
                      return <li
                      key={number}
                      id={number}
                      onClick={this.handleClick}
                      className={currentPage === number ? 'active' : ''}
                    >
                      {number}
                    </li>
                  })}
                </ul>
              </div>
            </div>
          </div>
        }

      </div>
        );
    }
}

DelayLogs.propTypes = {
    projectId: PropTypes.string.isRequired,
    permissions: PropTypes.object.isRequired,
    delayLogs: PropTypes.array.isRequired,
    fetchDelayLogs: PropTypes.func.isRequired,
};

function mapStateToProps (state, ownProps) {
    return {
        projectId: ownProps.projectId,
        delayLogs: state.projectsStore.delayLogs,
    };
}

export default connect(mapStateToProps, {fetchDelayLogs})(DelayLogs);